'use strict';

var ModalController = function ModalController($scope) {
  $scope.isModalVisible = false;
  $scope.setModalVisibility = function (visibility) {
    $scope.isModalVisible = !!visibility;
  };
};
ModalController.$inject = ['$scope'];
module.exports = ModalController;